import React from "react";
import { FiRefreshCcw, FiRotateCcw, FiSearch } from "react-icons/fi";

import AdminButton from "../../_shared/ui/AdminButton";

import {
  PUBLICATIONS_LIMIT_OPTIONS,
  PUBLICATIONS_STATUS_OPTIONS,
} from "../data/publicationsAdminData";

export default function PublicationsFiltersPanel({
  q,
  stateFilter,
  limit,
  onChangeQ,
  onChangeStateFilter,
  onChangeLimit,
  onSubmit,
  onReset,
  onRefresh,
  loading,
}) {
  return (
    <section className="mt-5 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <form
        onSubmit={onSubmit}
        className="grid gap-4 xl:grid-cols-[1fr_280px_160px_auto]"
      >
        <div>
          <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
            Rechercher une publication
          </label>

          <div className="mt-2 flex min-h-12 items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 transition focus-within:border-sky-400 focus-within:bg-white focus-within:ring-4 focus-within:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:focus-within:border-sky-500 dark:focus-within:ring-sky-500/10">
            <FiSearch className="text-slate-400" />

            <input
              value={q}
              onChange={(event) => onChangeQ(event.target.value)}
              placeholder="Titre, description, lien..."
              className="h-11 min-w-0 flex-1 bg-transparent text-sm font-medium text-slate-800 outline-none placeholder:text-slate-400 dark:text-slate-100"
            />
          </div>
        </div>

        <div>
          <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
            Statut
          </label>

          <div className="mt-2 grid grid-cols-3 gap-2 rounded-2xl border border-slate-200 bg-slate-50 p-1 dark:border-slate-700 dark:bg-slate-950">
            {PUBLICATIONS_STATUS_OPTIONS.map((option) => {
              const selected = stateFilter === option.value;

              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => onChangeStateFilter(option.value)}
                  className={`rounded-xl px-3 py-2 text-xs font-bold transition ${
                    selected
                      ? "bg-sky-600 text-white shadow-sm"
                      : "text-slate-500 hover:bg-white hover:text-slate-800 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-white"
                  }`}
                  title={option.description}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>

        <div>
          <label className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
            Affichage
          </label>

          <select
            value={limit}
            onChange={(event) => onChangeLimit(Number(event.target.value))}
            className="mt-2 h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:focus:border-sky-500 dark:focus:ring-sky-500/10"
          >
            {PUBLICATIONS_LIMIT_OPTIONS.map((value) => (
              <option key={value} value={value}>
                {value} / page
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-wrap items-end gap-2 xl:justify-end">
          <AdminButton
            type="submit"
            icon={FiSearch}
            variant="dark"
            loading={loading}
          >
            Rechercher
          </AdminButton>

          <AdminButton
            icon={FiRefreshCcw}
            variant="secondary"
            onClick={onRefresh}
            loading={loading}
          >
            Actualiser
          </AdminButton>

          <AdminButton icon={FiRotateCcw} variant="ghost" onClick={onReset}>
            Réinitialiser
          </AdminButton>
        </div>
      </form>
    </section>
  );
}